import { Typography } from '@packages/ui/shared';
import { DATE_FORMAT } from '@web/config/constants';
import { getDisplayDate } from '@web/utils';
import { type FC, memo } from 'react';
import { useTranslation } from 'react-i18next';

const NO_DATE = '--';

type ReferenceDataLastUpdatedProps = {
    sourceDataDate: string | null;
};

export const ReferenceDataLastUpdated: FC<ReferenceDataLastUpdatedProps> = memo(({ sourceDataDate }) => {
    const { t } = useTranslation();

    let formattedDate = NO_DATE;

    if (sourceDataDate) {
        try {
            formattedDate = getDisplayDate(sourceDataDate, DATE_FORMAT.MMM_D_YEAR, NO_DATE);
        } catch {
            // getDisplayDate throws on an unparseable value; an absent date must not break the page.
            formattedDate = NO_DATE;
        }
    }

    return (
        <Typography color="graySix" variant="caption">
            {t('cidCvnCheck:referenceDataLastUpdated', { date: formattedDate })}
        </Typography>
    );
});
